import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PaperWriterPage = lazy(() => import('../pages/paper-writer/page'));
const GeniusMathPage = lazy(() => import('../pages/genius-math/page'));
const DigitalAISearchPage = lazy(() => import('../pages/digital-ai-search/page'));
const ResumeBuilderPage = lazy(() => import('../pages/resume-builder/page'));
const ResumeEditorPage = lazy(() => import('../pages/resume-editor/page'));
const BusinessPlanWriterPage = lazy(() => import('../pages/business-plan-writer/page'));
const EbookCreatorPage = lazy(() => import('../pages/ebook-creator/page'));
const PresentationCreatorPage = lazy(() => import('../pages/presentation-creator/page'));
const WebsiteBuilderPage = lazy(() => import('../pages/website-builder/page'));
const WebsiteBuilderCategoryPage = lazy(() => import('../pages/website-builder/categories/page'));
const WebsiteBuilderDetailPage = lazy(() => import('../pages/website-builder/detail/page'));
const AIImageGeneratorPage = lazy(() => import('../pages/ai-image-generator/page'));
const MasterArchitectPage = lazy(() => import('../pages/master-architect/page'));
const AIVideoPage = lazy(() => import('../pages/ai-video/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/paper-writer',
    element: <PaperWriterPage />,
  },
  {
    path: '/genius-math',
    element: <GeniusMathPage />,
  },
  {
    path: '/digital-ai-search',
    element: <DigitalAISearchPage />,
  },
  {
    path: '/resume-builder',
    element: <ResumeBuilderPage />,
  },
  {
    path: '/resume-editor',
    element: <ResumeEditorPage />,
  },
  {
    path: '/business-plan-writer',
    element: <BusinessPlanWriterPage />,
  },
  {
    path: '/ebook-creator',
    element: <EbookCreatorPage />,
  },
  {
    path: '/presentation-creator',
    element: <PresentationCreatorPage />,
  },
  {
    path: '/website-builder',
    element: <WebsiteBuilderPage />,
  },
  {
    path: '/website-builder/category/:slug',
    element: <WebsiteBuilderCategoryPage />,
  },
  {
    path: '/website-builder/template/:slug',
    element: <WebsiteBuilderDetailPage />,
  },
  {
    path: '/ai-image-generator',
    element: <AIImageGeneratorPage />,
  },
  {
    path: '/master-architect',
    element: <MasterArchitectPage />,
  },
  {
    path: '/ai-video',
    element: <AIVideoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;